import { SignupPageStep } from '@/_shared/enums/sign-up-page-step.enum';
import { SignupState } from '../states/signup.state';
import { Draft, PayloadAction, createSlice } from '@reduxjs/toolkit';

const signUpInitialValue = {
  firstName: '',
  lastName: '',
  phoneNumber: '',
  country: '',
  email: '',
  password: '',
  confirmPassword: '',
  isUserConsentAccepted: false,
  isUserTrackingEnabled: false,
};

const initialState: SignupState = {
  signupRequest: signUpInitialValue,
  signupRequestInitialValue: signUpInitialValue,
  step: SignupPageStep.personalDetails,
} as const;

export const signupSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    reset: () => initialState,
    setSignupRequest: (
      state: Draft<typeof initialState>,
      action: PayloadAction<typeof initialState.signupRequest>
    ) => {
      state.signupRequest = action.payload;
    },
    setStep: (
      state: Draft<typeof initialState>,
      action: PayloadAction<typeof initialState.step>
    ) => {
      state.step = action.payload;
    },
  },
});

export const getSignupState = (state: { signup: SignupState }) => state.signup;
export const { setSignupRequest, setStep, reset } = signupSlice.actions;
export default signupSlice.reducer;
